/* eslint-disable no-template-curly-in-string */
import R from 'ramda'

const INSTAGRAM_COMMENT_REPLY_DISPLAY_TYPE = 'Send Instagram Comment Reply'
const INSTAGRAM_COMMENT_REPLY_WIDGET_TYPE = 'SEND_INSTAGRAM_COMMENT_REPLY'

const isInstagramCommentReplyFormAction = R.propEq(
  'type',
  INSTAGRAM_COMMENT_REPLY_DISPLAY_TYPE
)

const convertFormCommentToWidget = R.applySpec({
  type: R.always(INSTAGRAM_COMMENT_REPLY_WIDGET_TYPE),
  message: {
    message: R.prop('igCommentReplyMessage')
  }
})

export { isInstagramCommentReplyFormAction, convertFormCommentToWidget }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/instagram/form-to-widget/instagram-comment-reply.js